/*@ngInject*/
const RuleBuilderLeftNavController = function ($scope, $element, $rootScope, $state, authorizationConstants, coreConstant, currentUserModel, formViewerConstant, localization,
                                               modalUtil, ruleMediator, ruleUtil, umStudioConstant, configurationMediator, configurationActionsUtil, loadingBarHandler, uiFormTemplateModel) {

    $element.addClass('ruleBuilderLeftNav');

    localization.getTranslations().then(function (translations) {

        this.navigationItemList = [];
        this.selectedItem = null;
        this.userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
        this.newRuleText = _.get(translations, 'ruleBuilderLeftNav.newRule');

        this.$onInit = function () {
            this.constructNavigationItemList();
        };

        this.$onChanges = function () {
            this.constructNavigationItemList();
        };

        this.constructNavigationItemList = function () {
            var fieldRuleNavItems = [],
                navItem,
                firstChildItem,
                selectedItemInList;

            this.navigationItemList = [];

            this.isSupplemental = !this.uiFormTemplate.formTemplate.root && !_.isNil(this.uiFormTemplate.triggerRule);
            this.isConditional = this.uiFormTemplate.formTemplate.root && !_.isNil(this.uiFormTemplate.triggerRule);

            if (this.isConditional) {
                this.navigationItemList.push({
                    name: _.get(translations, 'ruleBuilderLeftNav.conditionalFormRule'),
                    children: null,
                    value: 'conditionalFormRule'
                });
            } else if (this.isSupplemental) {
                this.navigationItemList.push({
                    name: _.get(translations, 'ruleBuilderLeftNav.supplementalFormRule'),
                    children: null,
                    value: 'supplementalFormRule'
                });
            }

                if (this.uiFormTemplate.fieldRules) {
                    _.each(this.uiFormTemplate.fieldRules, function (fieldRule) {
                        var nameSubstring = fieldRule.name.lastIndexOf('-#') !== -1 ? fieldRule.name.substr(0, fieldRule.name.lastIndexOf('-#')) : fieldRule.name;
                        var navItem = {
                                name: nameSubstring,
                                children: null,
                                value: fieldRule
                            };
                        var fieldRuleName = uiFormTemplateModel.getSelectedFieldRuleName() ? uiFormTemplateModel.getSelectedFieldRuleName() : $state.params.ruleName;
                        fieldRuleNavItems.push(navItem);
                        if (fieldRuleName && nameSubstring===fieldRuleName) {
                            this.selectedItem = navItem;
                        }

                    if(this.selectedItem && this.selectedItem.value === fieldRule){
                        selectedItemInList = true;
                    }
                }.bind(this));
            }

            fieldRuleNavItems = _.sortBy(fieldRuleNavItems, ['name']);

            this.navigationItemList.push({
                name: _.get(translations, 'ruleBuilderLeftNav.fieldRules'),
                children: fieldRuleNavItems,
                value: 'fieldRules'
            });



            if (selectedItemInList) {
                this.onNavChildItemClick(this.selectedItem);
            } else {
                navItem = this.navigationItemList[0];
                if (navItem.value === 'fieldRules') {
                    if (navItem.children && navItem.children.length > 0) {
                        firstChildItem = navItem.children[0];
                        this.onNavChildItemClick(firstChildItem);
                    }
                } else {
                    this.onNavItemClick(navItem.value);
                }
            }
        };

        this.onNavItemClick = function (itemValue) {
            var item = _.find(this.navigationItemList, function (navigationItem) {
                return navigationItem.value === itemValue;
            });


            $rootScope.$broadcast(umStudioConstant.event.FORM_RULE_SELECTED);

            this.notifyChange(item);
        };

        this.onNavChildItemClick = function (item, focusOnRuleName, isNewRule) {
            $rootScope.$broadcast(umStudioConstant.event.FIELD_RULE_SELECTED, item.value, focusOnRuleName, isNewRule);

            this.notifyChange(item);
        };

        this.notifyChange = function (item) {
            this.selectedItem = item;
        };

        this.hasChildren = function (item) {
            return this.hasFieldRules(item) || item.value === 'fieldRules';
        };

        this.hasFieldRules = function (item) {
            return !_.isEmpty(item.children);
        };

        this.onDeleteFieldRuleClick = function (navItem, childNavItemToDelete, fieldRuleToDelete) {

            function doDeleteFieldRule() {
                var index,
                    nextSelectedIndex,
                    nextSelectedItem = null,
                    nextSelectedChildItem = null,
                    nameSubstring;

                _.remove(this.uiFormTemplate.fieldRules, function (fieldRule) {
                    return fieldRule.name === fieldRuleToDelete.name;
                });

                nameSubstring = ruleUtil.getRuleNameSubstring(fieldRuleToDelete);
                ruleUtil.cleanUpUiFieldsByTriggerRuleName(this.uiFormTemplate, nameSubstring);

                index = _.findIndex(navItem.children, function (childNavItem) {
                    return childNavItem.name === childNavItemToDelete.name;
                });

                if (navItem.children.length > 1) {
                    if (index === 0) {
                        nextSelectedIndex = 0;
                    } else if (index === navItem.children.length - 1) {
                        nextSelectedIndex = navItem.children.length - 2;
                    } else {
                        nextSelectedIndex = index;
                    }
                } else {
                    nextSelectedIndex = -1;
                }

                _.remove(navItem.children, function (childNavItem) {
                    return childNavItem.name === childNavItemToDelete.name;
                });

                loadingBarHandler.showLoadingBar('formEditor.saveUiFormTemplate.loadingBar');
                return configurationMediator.updateFormTemplate(this.uiFormTemplate, this.uiFormTemplate.id).then(function (uiFormTemplate) {
                    loadingBarHandler.hideLoadingBar();
                    return configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
                        var focusOnRuleName = false;
                        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, uiFormTemplate);
                        if (nextSelectedIndex >= 0 && navItem.children.length > 0) {
                            nextSelectedChildItem = navItem.children[nextSelectedIndex];
                            this.onNavChildItemClick(nextSelectedChildItem, focusOnRuleName);
                        } else {
                            nextSelectedItem = this.navigationItemList[0];
                            if (nextSelectedItem.value !== 'fieldRules') {
                                this.onNavItemClick(nextSelectedItem);
                            } else {
                                $rootScope.$broadcast(umStudioConstant.event.RESET_RULE_SELECTION);
                            }
                        }
                    }.bind(this));
                }.bind(this));

            }

            modalUtil.showConfirmationModal(
                /*submissionId*/null,
                /*quoteId*/null,
                /*notificationName*/null,
                'ruleBuilderLeftNav.deleteConfirmation',
                /*logAction*/null,
                /*hideLoadingBar*/true,
                doDeleteFieldRule.bind(this)
            );
        };

        this.onNewRuleClick = function () {
            var newFieldRule = ruleMediator.createFieldRule(this.uiFormTemplate.fieldRules),
                newFieldRuleNavItem = {
                    name: newFieldRule.name,
                    children: null,
                    value: newFieldRule
                },
                fieldRuleListNavItem = _.find(this.navigationItemList, function (navigationItem) {
                    return navigationItem.value === 'fieldRules';
                }),
                focusOnRuleName = true,
                isNewRule = true;

            if (_.isNil(this.uiFormTemplate.fieldRules)) {
                this.uiFormTemplate.fieldRules = [];
            }
            this.uiFormTemplate.fieldRules.push(newFieldRule);

            if (!_.isNil(fieldRuleListNavItem)) {
                fieldRuleListNavItem.children.push(newFieldRuleNavItem);
                this.onNavChildItemClick(newFieldRuleNavItem, focusOnRuleName, isNewRule);
            }

            $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
        };

        $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_OPENED, function () {
            $element.addClass('open');
        });

        $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_CLOSED, function () {
            $element.removeClass('open');
        });

        $scope.$on(umStudioConstant.event.CREATE_NEW_FIELD_RULE, function () {
            this.onNewRuleClick();
        }.bind(this));

        $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, function () {
            this.constructNavigationItemList();
        }.bind(this));

    }.bind(this));
};

angular.module('ums.configuration')
    .controller('ruleBuilderLeftNavController', RuleBuilderLeftNavController);
